import {ChangeDetectorRef, Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
    selector: "custom-gallery-image",
    template: `
        <img
                mat-card-image
                crossorigin="anonymous"
                [className]="className"
                [src]="src"
                (load)="isLoading = false; this.loadEvent.emit($event)"
        />
    `,
    styleUrls: ["./custom-gallery-image.component.scss"],
    standalone: false,
})
export class CustomGalleryImageComponent {
    isLoading: boolean = true;

    @Input() src: string;

    @Input() className: any;

    @Output() loadEvent = new EventEmitter<Event>();

    constructor(private cdr: ChangeDetectorRef) {}

    loadImageLazy(url: string) {
        this.src = url;
        this.cdr.detectChanges();
    }
}
